import { isRouteErrorResponse, useRouteError } from 'react-router-dom'
import './RouteError.css'

export default function RouteError ({ notFound = false }) {
  const error = useRouteError()
  const missing = notFound || (isRouteErrorResponse(error) && error.status === 404)

  return (
    <main className='route-error'>
      <section className='route-error-card' aria-labelledby='route-error-title'>
        <p className='route-error-brand'>Sustainability Tool Kit</p>
        <div className='route-error-illustration' aria-hidden='true'>
          <svg viewBox='0 0 160 120' fill='none'>
            <circle cx='80' cy='60' r='54' fill='currentColor' opacity='.08' />
            <path d='M54 30h38l18 18v44H54z' stroke='currentColor' strokeWidth='4' strokeLinejoin='round' />
            <path d='M92 30v20h18M67 65h29M67 78h18' stroke='currentColor' strokeWidth='4' strokeLinecap='round' />
            <circle cx='110' cy='88' r='17' fill='white' stroke='currentColor' strokeWidth='4' />
            <path d='m122 101 12 12' stroke='currentColor' strokeWidth='5' strokeLinecap='round' />
          </svg>
        </div>
        <p className='route-error-label'>{missing ? 'Page not found · 404' : 'Please try again'}</p>
        <h1 id='route-error-title'>{missing ? 'Let’s get you back on track' : 'We couldn’t open this page'}</h1>
        <p className='route-error-description'>
          {missing
            ? 'The link may be out of date, or the page may have moved. You can return home or find your work in Projects.'
            : 'Something went wrong while opening this page. Please try again, or return home to continue.'}
        </p>
        <div className='route-error-actions'>
          {!missing && <button className='route-error-primary' onClick={() => window.location.reload()}>Try again</button>}
          <a className={missing ? 'route-error-primary' : 'route-error-secondary'} href='/'>Return home</a>
          {missing && <a className='route-error-secondary' href='/projects'>Go to Projects</a>}
        </div>
      </section>
    </main>
  )
}
